import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'app-add-cse-form',
  templateUrl: './add-cse-form.component.html',
  styleUrls: ['./add-cse-form.component.scss']
})
export class AddCseFormComponent implements OnInit {
  submitBtnText = 'SUBMIT'
  @Output() showSideBar = new EventEmitter();
  showSideMenu: boolean = false;
  
  heading = [
    {
      title: 'Create CSE',
      // subTitle: 'Please provide the following details to continue'
    },
  ]

  inputDataList = [
    [
      {
        label: "Name Of The CSE",
        type: "text",
        controllerName: "name",
        required: true,
        valueType: "text",
        hide: false,
        placeholder: "Name Of The CSE",
        errorMsg: "Name Of The CSE",
      },
      {
        label: "Name Of The Lead Doctor",
        type: "text",
        controllerName: "lead_dr_name",
        required: true,
        valueType: "text",
        hide: false,
        placeholder: "Name Of The Lead Doctor",
        errorMsg: "Name Of The Lead Doctor",
      },
      {
        label: "Email ID Of The CSE",
        type: "email",
        controllerName: "email",
        required: false,
        valueType: "string",
        hide: false,
        placeholder: "Email ID Of The CSE",
        errorMsg: "email",
      },
      {
        label: "Contact Number Of CSE",
        type: "number",
        controllerName: "mobile",
        required: false,
        valueType: "number",
        hide: false,
        placeholder: "Contact Number Of CSE",
        errorMsg: "Contact Number Of CSE",
      },
      {
        label: "Pincode",
        type: "number",
        controllerName: "pincode",
        required: true,
        valueType: "number",
        hide: false,
        placeholder: "Pincode",
        errorMsg: "Pincode",
      },
      {
        label: "State",
        type: "text",
        controllerName: "state_name",
        required: true,
        valueType: "string",
        hide: false,
        placeholder: "State",
        errorMsg: "state",
        isDisable: true,
      },
      {
        label: "District",
        type: "text",
        controllerName: "district_name",
        required: true,
        valueType: "string",
        hide: false,
        placeholder: "District",
        errorMsg: "district",
        isDisable: true,
      },
      {
        label: "Block",
        type: "text",
        controllerName: "block_name",
        required: true,
        valueType: "string",
        hide: false,
        placeholder: "Region",
        errorMsg: "region",
        isDisable: true,
      },
      {
        label: "Current Status Of The CSE",
        type: "radio",
        option: [
          { name: 'Active', value: '1' },
          { name: 'Inactive', value: '2' },
        ],
        controllerName: "status",
        required: true,
        valueType: "string",
        hide: false,
        placeholder: "Current Status Of The CSE",
        errorMsg: "",
      },
      // {
      //   label: "Current Status Of The CSE",
      //   type: "toggle",
      //   option: [
      //     { name: 'Active', value: '1' },
      //     { name: 'Inactive', value: '2' },
      //   ],
      //   controllerName: "status",
      //   required: true,
      //   valueType: "string",
      //   hide: false,
      //   placeholder: "Current Status Of The CSE",
      //   errorMsg: "",
      // },
    ],
  ]
  queryParams: any;
  constructor(private router: Router, private adminService: AdminService, private route: ActivatedRoute,) {
    this.queryParams = this.route.snapshot.queryParams;
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }
    // console.log('after decrypted in add cse form', this.queryParams);
    
    if (this.queryParams?.userId != undefined) {
      this.submitBtnText = 'UPDATE';
    }

  }

  ngOnInit(): void {
  }

  submitData(response) {
    let payload = response[0].value;
    let token = sessionStorage.getItem("token");

    if (this.submitBtnText == 'SUBMIT') {
      // debugger
      this.adminService.createCSE(payload, token).subscribe((response: any) => {
        Swal.fire('Success', 'Data Submitted Successfully', 'success').then(() => {
          this.router.navigateByUrl('admin/cse-listing');
        })
      },
        (error) => {
          console.log(error.error.message);
          Swal.fire('Error', `${error.error.message}`, 'error')
        }
      )
    } else if (this.submitBtnText == 'UPDATE') {
      // debugger
      this.adminService.updateCSE(this.queryParams?.userId ,payload, token).subscribe((response: any) => {
        Swal.fire('Success', 'Data Updated Successfully', 'success').then(() => {
          this.router.navigateByUrl('admin/cse-listing');
        })
      },
        (error) => {
          console.log(error.error.message);
          Swal.fire('Error', `${error.error.message}`, 'error')
        }
      )
    }
  }

  formButtonResEvent(response) {
    console.log("inside detailed form", response);
    if (response[0].status == 'VALID') {
      // Swal.fire('Sucess', 'Form DATA is VALID', 'success')
      this.submitData(response)
      console.log('response', response);
    }
  }

  backIconClick() {
    this.router.navigateByUrl('/admin/cse-listing');
  }
  
  showSideBarMenu() {
    this.showSideMenu = !this.showSideMenu;
    this.showSideBar.emit(this.showSideMenu)
  }

}
